import { COLLECTIONS, isValidPayload, store, toErrorResult } from './shared';

const STATUS_DEFAULT = 'Aguardando respostas';

const byUpdatedAtDesc = (a, b) => {
  const aTime = new Date(a && a.updated_at ? a.updated_at : 0).getTime();
  const bTime = new Date(b && b.updated_at ? b.updated_at : 0).getTime();
  return bTime - aTime;
};

const list = async () => {
  const result = await store.list(COLLECTIONS.avaliacoes);

  if (!result.ok) {
    return result;
  }

  const items = Array.isArray(result.data) ? [...result.data].sort(byUpdatedAtDesc) : [];
  return { ok: true, data: items, error: null };
};

const getById = async id => store.getById(COLLECTIONS.avaliacoes, id);

const create = async payload => {
  try {
    if (!isValidPayload(payload)) {
      return toErrorResult(new Error('Payload inválido para criação de avaliação'));
    }

    const hasCriticalField = Boolean(payload.titulo || payload.nome || payload.modelo_id);
    if (!hasCriticalField) {
      return toErrorResult(new Error('Payload de avaliação sem campos críticos'));
    }

    return await store.create(COLLECTIONS.avaliacoes, {
      ...payload,
      status: payload && payload.status ? payload.status : STATUS_DEFAULT
    });
  } catch (error) {
    return toErrorResult(error);
  }
};

const update = async (id, payload) => {
  if (!isValidPayload(payload)) {
    return toErrorResult(new Error('Payload inválido para atualização de avaliação'));
  }

  const hasCriticalField = Boolean(payload.titulo || payload.nome || payload.modelo_id || payload.status);
  if (!hasCriticalField) {
    return toErrorResult(new Error('Payload de avaliação sem campos críticos'));
  }

  return store.update(COLLECTIONS.avaliacoes, id, payload);
};

const remove = async id => store.remove(COLLECTIONS.avaliacoes, id);

const getByAvaliacaoId = async avaliacaoId => {
  const result = await list();

  if (!result.ok) {
    return result;
  }

  const filtered = Array.isArray(result.data)
    ? result.data.find(item => item && item.avaliacao_id === avaliacaoId) || null
    : null;

  return { ok: true, data: filtered, error: null };
};

const avaliacoesRepo = {
  list,
  getById,
  getByAvaliacaoId,
  create,
  update,
  remove
};

export default avaliacoesRepo;
